import { isNil } from 'lodash-es';
import { isSameDay } from 'date-fns';
export interface DateOfStayAttributes {
  start: Date | null;
  end: Date | null;
}

export class DateOfStay implements DateOfStayAttributes {
  start: Date | null = null;
  end: Date | null = null;

  constructor(attributes: DateOfStayAttributes | null) {
    if (!!attributes) {
      const { start, end } = attributes;
      
      this.start = start;
      this.end = end;
    }
  }

  isStartAndEndSet(): boolean {
    return !isNil(this.start) && !isNil(this.end);
  }

  isSame(otherDate: DateOfStay): boolean {

    return this.isStartAndEndSet() &&
      otherDate.isStartAndEndSet() &&
      isSameDay(this.start!, otherDate.start!) &&
      isSameDay(this.end!, otherDate.end!);
  }

  formatStartDate(): string {
    return this.start?.toISOString() ?? '';
  }
}
